import { render, staticRenderFns } from "./OrganizationalManagement.vue?vue&type=template&id=3a73308a&scoped=true"
import script from "./OrganizationalManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationalManagement.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalManagement.vue?vue&type=style&index=0&id=3a73308a&prod&lang=scss"
import style1 from "./OrganizationalManagement.vue?vue&type=style&index=1&id=3a73308a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73308a",
  null
  
)

export default component.exports